"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var models_exports = {};
module.exports = __toCommonJS(models_exports);
__reExport(models_exports, require("./add-partial-transcript"), module.exports);
__reExport(models_exports, require("./add-partial-translation"), module.exports);
__reExport(models_exports, require("./add-transcript"), module.exports);
__reExport(models_exports, require("./add-translation"), module.exports);
__reExport(models_exports, require("./alignment-config"), module.exports);
__reExport(models_exports, require("./audio-added"), module.exports);
__reExport(models_exports, require("./audio-format"), module.exports);
__reExport(models_exports, require("./audio-format-file"), module.exports);
__reExport(models_exports, require("./audio-format-raw"), module.exports);
__reExport(models_exports, require("./auto-chapters-result-error"), module.exports);
__reExport(models_exports, require("./batch-recognition-alternative"), module.exports);
__reExport(models_exports, require("./batch-recognition-display"), module.exports);
__reExport(models_exports, require("./batch-recognition-metadata"), module.exports);
__reExport(models_exports, require("./batch-recognition-result"), module.exports);
__reExport(models_exports, require("./batch-transcription-config"), module.exports);
__reExport(models_exports, require("./batch-transcription-config-additional-vocab-inner"), module.exports);
__reExport(models_exports, require("./batch-transcription-config-punctuation-overrides"), module.exports);
__reExport(models_exports, require("./batch-transcription-config-speaker-diarization-config"), module.exports);
__reExport(models_exports, require("./batch-translation-config"), module.exports);
__reExport(models_exports, require("./chapter"), module.exports);
__reExport(models_exports, require("./create-job-response"), module.exports);
__reExport(models_exports, require("./data-fetch-config"), module.exports);
__reExport(models_exports, require("./delete-job-response"), module.exports);
__reExport(models_exports, require("./end-of-stream"), module.exports);
__reExport(models_exports, require("./end-of-transcript"), module.exports);
__reExport(models_exports, require("./error-response"), module.exports);
__reExport(models_exports, require("./info"), module.exports);
__reExport(models_exports, require("./job-config"), module.exports);
__reExport(models_exports, require("./job-detail-error"), module.exports);
__reExport(models_exports, require("./job-details"), module.exports);
__reExport(models_exports, require("./job-info"), module.exports);
__reExport(models_exports, require("./job-mode"), module.exports);
__reExport(models_exports, require("./job-type"), module.exports);
__reExport(models_exports, require("./language-identification-config"), module.exports);
__reExport(models_exports, require("./max-delay-mode-config"), module.exports);
__reExport(models_exports, require("./model-error"), module.exports);
__reExport(models_exports, require("./notification-config"), module.exports);
__reExport(models_exports, require("./operating-point"), module.exports);
__reExport(models_exports, require("./output-config"), module.exports);
__reExport(models_exports, require("./output-config-srt-overrides"), module.exports);
__reExport(models_exports, require("./punctuation-overrides"), module.exports);
__reExport(models_exports, require("./realtime-diarization-config"), module.exports);
__reExport(models_exports, require("./realtime-message"), module.exports);
__reExport(models_exports, require("./realtime-recognition-alternative"), module.exports);
__reExport(models_exports, require("./realtime-recognition-display"), module.exports);
__reExport(models_exports, require("./realtime-recognition-metadata"), module.exports);
__reExport(models_exports, require("./realtime-recognition-result"), module.exports);
__reExport(models_exports, require("./realtime-speaker-diarization-config"), module.exports);
__reExport(models_exports, require("./realtime-transcription-config"), module.exports);
__reExport(models_exports, require("./realtime-translation-config"), module.exports);
__reExport(models_exports, require("./recognition-started"), module.exports);
__reExport(models_exports, require("./retrieve-job-response"), module.exports);
__reExport(models_exports, require("./retrieve-jobs-response"), module.exports);
__reExport(models_exports, require("./retrieve-transcript-response"), module.exports);
__reExport(models_exports, require("./sentiment-analysis-error"), module.exports);
__reExport(models_exports, require("./sentiment-analysis-result"), module.exports);
__reExport(models_exports, require("./sentiment-analysis-result-sentiment-analysis"), module.exports);
__reExport(models_exports, require("./sentiment-channel-summary"), module.exports);
__reExport(models_exports, require("./sentiment-segment"), module.exports);
__reExport(models_exports, require("./sentiment-speaker-summary"), module.exports);
__reExport(models_exports, require("./sentiment-summary"), module.exports);
__reExport(models_exports, require("./sentiment-summary-detail"), module.exports);
__reExport(models_exports, require("./set-recognition-config"), module.exports);
__reExport(models_exports, require("./start-recognition"), module.exports);
__reExport(models_exports, require("./summarization-config"), module.exports);
__reExport(models_exports, require("./summarization-error"), module.exports);
__reExport(models_exports, require("./summarization-result"), module.exports);
__reExport(models_exports, require("./topic-detection-config"), module.exports);
__reExport(models_exports, require("./topic-detection-error"), module.exports);
__reExport(models_exports, require("./topic-detection-result"), module.exports);
__reExport(models_exports, require("./topic-detection-result-topics"), module.exports);
__reExport(models_exports, require("./topic-detection-segment"), module.exports);
__reExport(models_exports, require("./topic-detection-segment-topic"), module.exports);
__reExport(models_exports, require("./topic-detection-summary"), module.exports);
__reExport(models_exports, require("./tracking-data"), module.exports);
__reExport(models_exports, require("./translated-sentence"), module.exports);
__reExport(models_exports, require("./translation-error"), module.exports);
__reExport(models_exports, require("./translation-sentence"), module.exports);
__reExport(models_exports, require("./usage-details"), module.exports);
__reExport(models_exports, require("./usage-response"), module.exports);
__reExport(models_exports, require("./vocab-word"), module.exports);
__reExport(models_exports, require("./vocab-word-one-of"), module.exports);
__reExport(models_exports, require("./warning"), module.exports);